import {Injectable} from '@angular/core';
import { Act48Api } from '../api/act48.api';
import { CplA48ParaReportRequest } from '../model/cpl-a48-para-report-reqest.model';

@Injectable()
export class Act48ReportService {
    constructor(private  act48Api: Act48Api) { }

    getParaeducatorReport = ( request:CplA48ParaReportRequest) => this.act48Api.GetParaEducatorReport(request)
}